/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetPatientExerciseSchema } from '../models/GetPatientExerciseSchema';
import type { PatchPatientExerciseSchema } from '../models/PatchPatientExerciseSchema';
import type { PostPatientExerciseSchema } from '../models/PostPatientExerciseSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthPatientExercisesApi {
    /**
     * Api Post
     * Create patient exercises.<br>Required permission: edit_patient_exercises
     * @returns GetPatientExerciseSchema Created
     * @throws ApiError
     */
    public static patientExercisesApiPostPost({
        requestBody,
    }: {
        requestBody: PostPatientExerciseSchema,
    }): CancelablePromise<GetPatientExerciseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patient-exercises/auth/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Api Delete
     * Delete patient exercise.<br>Required permission: edit_patient_exercises
     * @returns void
     * @throws ApiError
     */
    public static patientExercisesApiDeleteDelete({
        patientExerciseId,
    }: {
        patientExerciseId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/patient-exercises/auth/{patient_exercise_id}/',
            path: {
                'patient_exercise_id': patientExerciseId,
            },
        });
    }
    /**
     * Api Patch
     * Patch patient exercises.<br>Required permission: edit_patient_exercises
     * @returns GetPatientExerciseSchema Created
     * @throws ApiError
     */
    public static patientExercisesApiPatchPatch({
        patientExerciseId,
        requestBody,
    }: {
        patientExerciseId: string,
        requestBody: PatchPatientExerciseSchema,
    }): CancelablePromise<GetPatientExerciseSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/patient-exercises/auth/{patient_exercise_id}/',
            path: {
                'patient_exercise_id': patientExerciseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
